<template>
  <v-container class="pt-0 pb-15 px-0">
    <v-responsive max-width="1080" class="mx-auto">
      <v-card
        class="py-7"
        :class="titleHeaderClass"
        elevation="0"
        tile>
        <v-card-title class="justify-center text-h4 font-weight-black grey--text text--darken-2">お問い合わせ</v-card-title>
      </v-card>
      <v-card tile flat class="d-flex flex-column align-center my-7">
        <v-card-title class="form_ttl">確認画面</v-card-title>
      </v-card>
      <form @submit.prevent="submit">
        <v-sheet :class="subHeaderClass">
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            お名前
          </v-subheader>
        </v-sheet>
        <p class="pt-5 px-4">{{ formItems.name }}</p>

        <v-sheet :class="subHeaderClass">
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            メールアドレス
          </v-subheader>
        </v-sheet>
        <p class="pt-5 px-4">{{ formItems.email }}</p>

        <v-sheet :class="subHeaderClass">
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            お問い合わせの種類
          </v-subheader>
        </v-sheet>
        <p class="pt-5 px-4">{{ selectedInquiryType }}</p>

        <v-sheet :class="subHeaderClass">
          <v-subheader class="font-weight-black text-subtitle-1 grey--text text--darken-4">
            お問い合わせ内容
          </v-subheader>
        </v-sheet>
        <p class="pt-5 px-4" style="white-space: pre-wrap;">{{ formItems.inquiryDetail }}</p>

        <v-row class="ma-0 mt-10">
          <v-col>
            <v-btn
              class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pl-2"
              color="grey lighten-1"
              width="120"
              height="60"
              :to="{name: 'InquiryForm'}">
              <v-icon left>mdi-chevron-left</v-icon>
              戻る
            </v-btn>
          </v-col>
          <v-col class="mr-7">
            <v-btn
              class="d-flex white--text text-subtitle-1 mx-auto rounded-lg pr-2"
              color="#EF0B68"
              width="100%"
              max-width="240"
              height="60"
              :disabled="disabled"
              @click="validateInquiryForm"
            >
              送信する
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>

      </form>
    </v-responsive>
    <v-dialog v-model="dialogApplyInquiryError" max-width="440">
      <v-card>
        <v-card-title class="text-h6 mb-4 justify-center">
          エラーが発生しました
        </v-card-title>

        <v-card-text>
          <p class="mb-0">エラーを検出したため、実行することができませんでした。</p>
          <p class="mb-2">しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="dialogApplyInquiryError = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "inquiry-confirm",
  props: {
    inquiryTypes: {
      type: Array,
      default: () => {}
    },
    titleHeaderClass: {
      type: String,
      default: "",
    },
    subHeaderClass: {
      type: String,
      default: "",
    }
  },
  data: () => ({
    disabled: false,
    dialogApplyInquiryError: false
  }),
  methods: {
    ...mapActions('inquiry', [
      'applyInquiryForm',
      'validateInquiry'
    ]),
    validateInquiryForm() {
      // サーバサイドバリデーション実施
      this.validateInquiry().then(response => {
        if(response.status === 200) {
          this.applyForInquiry();
        }
      }).catch(error => {
        if (error.response.status === 422) {
          this.$router.push({
            name: "InquiryForm",
            params: { errors: error.response.data.errors }
          });
        } else {
          this.dialogApplyInquiryError = true;
        }
      });
    },
    applyForInquiry() {
      this.disabled = true;
      this.applyInquiryForm().then(response => {
        response.status === 200 ? this.$router.push({name: "InquiryComplete"}) : this.disabled = false;
      }).catch(error => {
        this.disabled = false;
        this.dialogApplyInquiryError = true;
      });
    }
  },
  computed: {
    ...mapGetters('inquiry', [
      'getFormItems'
    ]),
    formItems() {
      return this.getFormItems;
    },
    inquiryTypeItems() {
      return this.inquiryTypes;
    },
    selectedInquiryType() {
      if (this.formItems.inquiryTypeCode) {
        let selectedType = this.inquiryTypeItems.find(({code}) => code === this.formItems.inquiryTypeCode);
        return selectedType.name;
      }
    }
  }
}
</script>
